import React, { useState } from "react";
import { MdMenuOpen, MdOutlineMenu } from "react-icons/md";
import "./CategorySelector.css";

let __elakayInfoSource;
const __setElakayInfoSource = (infoSource) => { if (infoSource) __elakayInfoSource = infoSource; };
const __elakayText = (key, fallback) =>
  __elakayInfoSource?.laguangeElakay?.("frontElakayHardcodedText", __elakayInfoSource.languageAPI)?.["categoryselector"]?.[key] || fallback;

/**
 * ===== CATEGORY SELECTOR COMPACT - MINIMAL SPACE =====
 * Très simple, minimal padding/margin
 */

const CategorySelectorCompact = ({
  categories,
  elakayCategoryID,
  catSelectedSearch,
  setcatSelectedSearch,
  loadCategory,
  infoSource,
  filterObject,
  setCategory,
  setElakayCategoryID,
  setPub,
  setPubR,
  setPubC
}) => {
  __setElakayInfoSource(infoSource);

  // State pour hover des noms de catégories
  const [hoveredIndex, setHoveredIndex] = useState(null);

  // Liste des modes de sélection (clé logique + libellé traduit séparés)
  const selectionModes = [
    { mode: 'selection', label: __elakayText("t004", "By selection") },
    { mode: 'table', label: __elakayText("t005", "By clicking its name in the table") },
  ];

  // Handle radio selection mode
  const handleCatSelSea = (mode) => {
    setcatSelectedSearch(mode === 'selection');
  };

  // Check which mode is active
  const activeMode = () => (catSelectedSearch ? 'selection' : 'table');

  // Handle dropdown selection
  const seleteCategory = (event) => {
    const supcategory = event.target.value;
    if (catSelectedSearch && supcategory) {
      loadCategory(supcategory);
    }
  };

  // Handle back navigation
  const clickBack = (categoryId) => {
    loadCategory(categoryId);
  };

  // Handle category load
  const loadSelectCategory = (obj) => {
    setCategory(filterObject(obj, [], ["items"]));
    setElakayCategoryID(obj._id);
    setPub(obj.pub);
    setPubR(obj.image_r);
    setPubC(obj.image_c);
  };

  // categoriesName - Breadcrumb avec tailles progressives
  const categoriesName = (categories = []) => {
    const calculateFontSize = (index, totalElements) => {
      const maxSize = 25;
      const minSize = 16;
      const sizeStep = (maxSize - minSize) / (totalElements - 1);
      return maxSize - (index * sizeStep);
    };

    return (
      <div className="compact-breadcrumb">
        {Array.isArray(categories.name) && categories.name?.map((name, index) => (
          index !== 0 && (
            <span key={index} className="compact-breadcrumb-item">
              <span
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
                onClick={() => clickBack(categories.categoryID[index])}
                className="compact-breadcrumb-link"
                style={{
                  cursor: 'pointer',
                  color: hoveredIndex === index ? '#007399' : '#495057',
                  fontSize: `${calculateFontSize(index, categories.name?.length)}px`
                }}
              >
                {name}
              </span>
              {index < categories.name?.length - 1 && (
                <span className="compact-breadcrumb-separator"> / </span>
              )}
            </span>
          )
        ))}
      </div>
    );
  };

  // CheckingCat - Header avec retour preview
  const CheckingCat = () => {
    return (
      <div className="compact-header">
        <h2 className={categories._id === elakayCategoryID ? 'active' : ''}>
          <span onClick={() => clickBack(categories._id)}>
            {categories?.name?.length > 0 && categories.name[0]}
          </span>
        </h2>
        {categoriesName && categoriesName(categories)}
        
        <div className="compact-radio-group">
          {selectionModes.map(({ mode, label }) => (
            <label
              key={mode}
              className={`compact-radio-label ${activeMode() === mode ? 'active' : ''}`}
            >
              <input
                className="compact-radio-input"
                onChange={() => handleCatSelSea(mode)}
                checked={activeMode() === mode}
                type="radio"
                name="typeList"
                id={"typeList_" + mode}
              />
              <span className="compact-radio-icon">
                {activeMode() === mode ? '●' : '○'}
              </span>
              <span className="compact-radio-text">{label}</span>
            </label>
          ))}
        </div>
      </div>
    );
  };

  // Render dropdown selector
  const renderDropdownSelector = () => (
    <div className="compact-dropdown">
      <select onChange={seleteCategory} className="compact-select" defaultValue="">
        <option value="" disabled>
          {infoSource.laguangeElakay('label', infoSource.languageAPI).selectProdSell || "Select"}
        </option>
        {categories?.items?.map((c, i) => (
          <option key={i} value={c.supCategoryID._id}>
            {infoSource.getCategoryNames(c).name.slice(0, -1).join(' › ')}
          </option>
        ))}
      </select>
    </div>
  );

  // Render table view
  const renderTableView = () => (
    <div className="compact-table">
      {categories?.items?.map((c, i) => {
        const isSelected = c.supCategoryID._id === elakayCategoryID;
        
        return (
          <div key={i} className={`compact-row ${isSelected ? 'selected' : ''}`}>
            <div className="compact-name">
              {infoSource.getCategoryNames(c).name.slice(0, -1).join(' › ')}
            </div>
            <div className="compact-actions">
              <button
                className="compact-btn compact-btn-open"
                onClick={() => loadSelectCategory(c.supCategoryID)}
                title={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).categoryselector.t001}
              >
                <MdMenuOpen />
              </button>
              <button
                className="compact-btn compact-btn-explore"
                onClick={() => clickBack(c.supCategoryID._id)}
                title={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).categoryselector.t002}
              >
                <MdOutlineMenu />
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );

  // Main render
  return (
    <div className="compact-selector">
      {CheckingCat()}
      <div className="compact-content">
        {categories?.items?.length > 0 ? (
          catSelectedSearch ? renderDropdownSelector() : renderTableView()
        ) : (
          <div className="compact-empty">{infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).categoryselector.t003}</div>
        )}
      </div>
    </div>
  );
};

export default CategorySelectorCompact;